import { LANGUAGE } from "@/common/utils/constants.js";

export const LANDING_PAGE = {
	[LANGUAGE.en.short]: {
		drc: "Digital Reference Catalogue",
		drcDescription: "A digital platform showcasing client success stories to help teams reach new opportunities",
		exploreDrc: "Explore DRC",
		gop: "Group Offer Portfolio",
		gopDescription: "An extensive suite of global portfolio offers covering key industries and tech practices",
		exploreGop: "Explore GOP",
	},
	[LANGUAGE.de.short]: {
		drc: "Digitaler Referenzkatalog",
		drcDescription: "Eine digitale Plattform, die Erfolgsgeschichten von Kunden präsentiert, um Teams zu helfen, neue Möglichkeiten zu erreichen",
		exploreDrc: "DRC erkunden",
		gop: "Gruppenangebotsportfolio",
		gopDescription: "Eine umfangreiche Suite globaler Portfolioangebote, die Schlüsselindustrien und Technologiepraktiken abdecken",
		exploreGop: "GOP erkunden",
	},
	[LANGUAGE.fr.short]: {
		drc: "Catalogue de référence numérique",
		drcDescription: "Une plateforme numérique présentant des histoires de réussite de clients pour aider les équipes à atteindre de nouvelles opportunités",
		exploreDrc: "Explorer DRC",
		gop: "Portefeuille d'offres de groupe",
		gopDescription: "Une vaste gamme d'offres de portefeuille mondial couvrant des secteurs et des pratiques technologiques clés",
		exploreGop: "Explorer GOP",
	},
	[LANGUAGE.it.short]: {
		drc: "Catalogo di riferimento digitale",
		drcDescription: "Una piattaforma digitale che mostra le storie di successo dei clienti per aiutare le squadre a raggiungere nuove opportunità",
		exploreDrc: "Esplora DRC",
		gop: "Portafoglio offerte di gruppo",
		gopDescription: "Una vasta gamma di offerte di portafoglio globale che coprono settori chiave e pratiche tecnologiche",
		exploreGop: "Esplora GOP",
	},
	[LANGUAGE.ja.short]: {
		drc: "デジタルリファレンスカタログ",
		drcDescription: "チームが新しい機会に到達するのを支援するために、顧客の成功事例を紹介するデジタルプラットフォーム",
		exploreDrc: "DRCを探索する",
		gop: "グループオファーポートフォリオ",
		gopDescription: "主要な業界と技術慣行をカバーする広範なグローバル ポートフォリオ スイートを提供",
		exploreGop: "GOPを探索する",
	},
	[LANGUAGE.es.short]: {
		drc: "Catálogo de referencia digital",
		drcDescription: "Una plataforma digital que muestra historias de éxito de clientes para ayudar a los equipos a alcanzar nuevas oportunidades",
		exploreDrc: "Explorar DRC",
		gop: "Portafolio de ofertas del grupo",
		gopDescription: "Una amplia gama de ofertas de portafolio global que cubren industrias clave y prácticas tecnológicas",
		exploreGop: "Explorar GOP",
	}
}
